import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbProgressbarModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ApproveRejectDialogComponent } from '../../Component/ApproveRejectDialog/approve-reject-dialog/approve-reject-dialog.component';

@Component({
  selector: 'app-mobile-register',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule],
  templateUrl: './mobile-register.component.html',
  styleUrl: './mobile-register.component.scss'
})
export class MobileRegisterComponent {
  isDisabled: boolean = false;
  EmployeeData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private toast: ToastService,
  ) {
    this.common.getPageRights();
    this.common.CompanyParameter();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESSEmpOnlineRegistrationRejectSelect();
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESSEmpOnlineRegistrationRejectSelect() {
    this.isDisabled = true;
    this.employeeRegistration.ESSEmpOnlineRegistrationRejectSelect({ EmployeeId: 0 }).subscribe({
      next: (response) => {
        this.EmployeeData = Object.values(response.Table)
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async Reject(EmpMasterID: number) {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ApproveRejectDialogComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.showReInitiat = false;
    modalRef.componentInstance.showApprove = false;

    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result != undefined && result != null && result != "") {
          this.isDisabled = true;
          this.employeeRegistration.ESSEmpOnlineRegistrationUpdate({ SelectType: 'R', EmpMasterID: EmpMasterID, Remark:result.Remark}).subscribe({
            next: (response) => {
              if (response.Error_Code == '50') {
                this.ESSEmpOnlineRegistrationRejectSelect();
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }
    });
  }
}
